import getEditorData from '../../Common/getEditorData';
import saveEditorData from '../../Common/saveEditorData';
import destroyEditorData from '../../Common/destroyEditorData';
import router from '../../../router/routes';
import axios from 'axios';

export default {
    namespaced: true,

    state: {
        userId: null,
        name: '',
        email: '',
        postData: [],
        password: null,
        profession: null,
        professions: [],
        role: 3,
        roleName: '',
        roles: [],
        route: '',
        adminNote: '',
        deleteDisabled: 0,
        projectClosing: false,
        userSaving: false,
    },

    getters: {
        name(state) {
            return state.name;
        },

        deleteDisabled(state) {
            return state.deleteDisabled;
        },

        email(state) {
            return state.email;
        },

        postData(state) {
            return {
                name: state.name,
                email: state.email,
                password: state.password,
                role: state.role,
                profession_id: state.profession,
                admin_note: state.adminNote
            };
        },

        password(state) {
            return state.password;
        },

        profession(state) {
            return state.profession;
        },

        professions(state) {
            return state.professions;
        },

        role(state) {
            return state.role;
        },

        roleName(state) {
            return state.roleName;
        },

        roles(state) {
            return state.roles;
        },

        adminNote(state) {
            return state.adminNote;
        },

        projectClosing(state) {
            return state.projectClosing;
        },

        userSaving(state) {
            return state.userSaving;
        },

        route(state) {
            if (state.userId) {
                return '/api/user/edit/' + state.userId;
            } else {
                return '/api/user/create';
            }
        },
    },

    mutations: {
        projectClosing(state, value) {
            state.projectClosing = value;
        },

        userSaving(state, value) {
            state.userSaving = value;
        },

        setUserId(state, value) {
            state.userId = value;
        },

        setName(state, value) {
            state.name = value;
        },

        setEmail(state, value) {
            state.email = value;
        },

        setPassword(state, value) {
            state.password = value;
        },

        setProfession(state, value) {
            state.profession = value;
        },

        setProfessions(state, value) {
            state.professions = value;
        },

        setRole(state, value) {
            state.role = value;
        },

        setRoleName(state, value) {
            state.roleName = value;
        },

        setRoles(state, value) {
            state.roles = value;
        },

        setAdminNote(state, value) {
            state.adminNote = value;
        },

        setDeleteDisabled(state, value) {
            state.deleteDisabled = value;
        }
    },

    actions: {
        getData({ commit, getters, state }) {
            commit('overlay/toggle', true, { root: true });

            getEditorData(getters.route).then((response) => {
                commit('setRoles', response.data.data.roles);
                commit('setProfessions', response.data.data.professions);
                if (state.userId) {
                    const user = response.data.data.user;
                    commit('setName', user.name ? user.name : '');
                    commit('setEmail', user.email ? user.email : '');
                    commit('setRole', user.roles[0].id);
                    commit('setRoleName', user.roles[0].name);
                    commit('setProfession', user.profession_id);
                    commit('setAdminNote', user.admin_note);
                    commit('setDeleteDisabled', user['protected']);
                } else {
                    // Make sure we don't return previous creation data.
                    // If you remove this, and someone who has previously created a card
                    // returns to the creation form, the previous card's data will still be there.
                    commit('setName', '');
                    commit('setEmail', '');
                    commit('setPassword', null);
                    commit('setRole', 5);
                    commit('setProfession', null);
                    commit('setAdminNote', '');
                    commit('setDeleteDisabled', 0);
                }

                commit('overlay/toggle', false, { root: true });
            });
        },

        saveData({ getters, commit }) {
            commit('userSaving', true);
            saveEditorData('user', getters.route, getters.postData)
                .then((userId) => {
                    commit('userSaving', false);
                    if (router.currentRoute.name === 'UserEdit') {
                        commit('overlay/toggle', false, { root: true });
                    } else {
                        router.push('/user/edit/' + userId);
                    }
                })
                .catch(() => {
                    commit('userSaving', false);
                });
        },

        destroyData({ state }) {
            destroyEditorData('/api/user/delete/' + state.userId)
                .then(() => {})
                .catch(() => {});
        },

        adminChangePassword({ state }, password) {
            return new Promise((resolve, reject) => {
                axios.post('/api/user/admin/change-password/' + state.userId, {'password': password})
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        closeProject({state, commit}){
            return new Promise((resolve, reject) => {
                commit('projectClosing', true);
                axios.post('/api/user/project-close/' +  state.userId)
                    .then(response => {
                        resolve(response);
                        commit('projectClosing', false);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
    },
};
